import { Component } from '@theme/component';
import { DialogCloseEvent } from '@theme/dialog';

const validationPatterns = {
  firstName: {
    pattern: /^[a-zA-Z\s'-]{2,50}$/,
    errorMessage: "First name must be 2-50 characters"
  },
  lastName: {
    pattern: /^[a-zA-Z\s'-]{2,50}$/,
    errorMessage: "Last name must bet 2-50 characters"
  },
  phone: {
    pattern: /^[+]?[0-9\s\-()]{7,20}$/,
    errorMessage: "Phone must be a proper phone number"
  },
  email: {
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    errorMessage: "Invalid email address"
  },
};

class QuoteRequestComponent extends Component {
    requiredRefs = ['form', 'submitButton', 'fallback', 'errorMessage', 'successMessage']

    constructor() {
      super();
      
      this.siteKey = this.dataset.siteKey;
      this.projectId= this.dataset.projectId;

      // product details
      this.productId = this.dataset.productId;
      this.productTitle = this.dataset.productTitle;
    }

    get dialog() {
      return this.closest('dialog-component');
    }

    connectedCallback() {
      super.connectedCallback();

      const { dialog } = this;

      if (dialog) {
        dialog.addEventListener(DialogCloseEvent.eventName, this.#handleDialogClose)
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback();
    }

    #handleDialogClose = () => {
      this.#clearImputsMessage();
    }

    onSubmit = async (event) => {
        event.preventDefault();

        const form = this.refs.form;
        const button = this.refs.submitButton;

        const formData = new FormData(form);

        formData.append('productId', this.productId);
        formData.append('productTitle', this.productTitle);
        
        const [result, data] = this.#validateImputs(formData);

        if (!result) {
          this.#displayFeedback(data);

          return;
        };

        const buttonText = button.textContent;
        button.textContent = 'Submitting...'
        button.disabled = true;

        // reCAPTCHA token
        const token = await grecaptcha.enterprise.execute(
          this.siteKey, { action: 'submit_form' }
        );
        formData.append('token', token);

        this.#setLoading();

        try {
            const url = 'https://carpentrylds.com/api/shop/quotations';
            const headers = {
              'Authorization': `Bearer WtXCFIySsSDI5wiwWvugLLLRrqyi7zsCQeK2yTOLzfh`
            }

            const response = await fetch(url, {
                method: 'POST',
                headers,
                body: formData
            });

            //throw new Error("Test error");

            this.#onSaveSuccess();
        } catch (error) {
            console.error(error);
            this.#onSaveError(error);
        }

        button.textContent = "Submit"
        button.disabled = false;
    }

    #validateImputs(formData) {
      this.#clearImputsMessage();

      let result = {}

      for (let [name, value] of formData.entries()) {
          const message = this.#validateField(name, value)

          if (message) {
              result[name] = message
          }
      }

      return [Object.keys(result).length === 0 ? true : false, result];
    }

    #clearImputsMessage() {
      const form = this.refs.form;
      const inputs = form.querySelectorAll('.contact-form__input');

      inputs.forEach(input => {
        const sibling = this.#getSibling(input, 'feedback');

        if (sibling) {
          sibling.classList.add('visually-hidden');
          sibling.textContent = '';
        }
      })
    }

    #validateField(fieldName, value) {
      const pattern = validationPatterns[fieldName]?.pattern;
      
      if (pattern && !pattern.test(value.trim())) {
          return validationPatterns[fieldName]?.errorMessage;
      }

      return '';
    }

    #getSibling(origin, className) {
      const parent = origin.parentElement;

      for (const child of parent.children) {
        if (child.classList.contains(className)) {
          return child;
        }
      }

      return null;
    }

    #displayFeedback(messages) {
      const form = this.refs.form;
      
      for (let result in messages) {
        const inputs = form.querySelectorAll('.contact-form__input');

        inputs.forEach((element) => {
          if (result === element.getAttribute('name')) {
            const sibling = this.#getSibling(element, 'feedback');

            if (sibling) {
              sibling.textContent = messages[result];
              sibling.classList.remove('visually-hidden');
            }
          }
        });
      }
    }

    #setLoading() {
      const fallback = this.refs.fallback

      fallback.classList.remove('visually-hidden');
    }

    #onSaveSuccess() {
      const fallback = this.refs.fallback;
      const successComponent = this.refs.successMessage;
      const form = this.refs.form;
      
      fallback.classList.add('visually-hidden');
      successComponent.classList.remove('visually-hidden');
      form.classList.add('visually-hidden');
    }

    #onSaveError(error) {
      const fallback = this.refs.fallback;
      const errorComponent = this.refs.errorMessage;
      
      fallback.classList.add('visually-hidden');
      errorComponent.classList.remove('visually-hidden');
    }
}

if (!customElements.get('quote-request-component')) {
    customElements.define('quote-request-component', QuoteRequestComponent)
}